(() => {
  const bindProduct = (root) => {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';
    const showMedia = (id) => {
      if (!id || !Array.from(root.querySelectorAll('[data-media-panel]')).some(el => el.dataset.mediaPanel === id)) return;
      root.querySelectorAll('[data-media-panel]').forEach(el => {
        el.hidden = el.dataset.mediaPanel !== id;
        if (el.hidden) el.querySelectorAll('video').forEach(video => video.pause());
      });
      root.querySelectorAll('[data-media-target]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mediaTarget === id)));
    };
    root.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
    const selector = root.querySelector('[data-variant-select]');
    if (!selector) return;
    const update = () => {
      const option = selector.selectedOptions[0];
      const button = root.querySelector('[data-add-button]');
      const valid = Boolean(option && option.value && !option.disabled);
      button.disabled = !valid;
      button.firstChild.textContent = valid ? 'Add to bag ' : (option?.value ? 'Sold out ' : 'Choose your size ');
      if (!option?.value) return;
      root.querySelector('[data-price]').textContent = option.dataset.price;
      const compare = root.querySelector('[data-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      showMedia(option.dataset.media);
      const url = new URL(location.href); url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    };
    selector.addEventListener('change', update); update();
  };
  const init = () => {
    document.querySelectorAll('[data-product-section]').forEach(bindProduct);
    const dialog = document.querySelector('[data-signup-dialog]');
    if (!dialog || dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    const key = 'afterimage-signup-dismissed';
    const remember = () => { try { localStorage.setItem(key, String(Date.now())); } catch {} };
    dialog.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', remember);
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    const response = dialog.querySelector('[data-signup-success], [data-signup-error]');
    if (response && location.hash.includes('NewsletterPopup')) { dialog.showModal(); return; }
    if (document.querySelector('[data-signup-success]')) { remember(); return; }
    if (window.Shopify?.designMode || location.pathname.includes('/cart') || location.pathname.includes('/challenge')) return;
    let last = 0; try { last = Number(localStorage.getItem(key) || 0); } catch {}
    if (Date.now() - last < 7 * 24 * 60 * 60 * 1000) return;
    setTimeout(() => {
      if (document.visibilityState === 'visible' && !document.querySelector('dialog[open]') && !['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName)) dialog.showModal();
    }, 14000);
  };
  init(); document.addEventListener('shopify:section:load', init);
})();
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || typeof drawer.showModal !== 'function') return;
  let busy = false, opener, changed = false;
  const error = drawer.querySelector('[data-cart-error]');
  const section = 'cart-drawer-content';
  const cartURL = drawer.dataset.cartUrl;
  const render = (html) => {
    if (typeof html !== 'string') throw new Error('Bag display unavailable.');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.querySelector('[data-cart-content]');
    if (!content) throw new Error('Bag display unavailable.');
    drawer.querySelector('[data-cart-content]').replaceWith(content);
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent = content.dataset.itemCount;});
  };
  const message = text => {error.textContent = text; error.hidden = !text;};
  const setBusy = value => {
    busy = value;
    drawer.querySelector('[data-cart-content]').setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-cart-change], [name="checkout"]').forEach(el => {el.disabled = value;});
  };
  const open = trigger => {
    opener = trigger || document.activeElement;
    if (!drawer.open) drawer.showModal();
    document.documentElement.classList.add('bag-open');
  };
  const refresh = async () => {
    const url = new URL(cartURL, location.origin); url.searchParams.set('sections', section);
    const response = await fetch(url.toString(), {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Unable to refresh bag.');
    const data = await response.json(); render(data[section]);
  };
  const applyResponse = async data => {
    if (data.sections?.[section]) render(data.sections[section]);
    else await refresh();
  };
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('bag-open');
    opener?.focus?.();
    if (changed && location.pathname === new URL(cartURL, location.origin).pathname) location.reload();
  });
  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-cart-close]')) drawer.close();
    if (event.target === drawer) {
      const r = drawer.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) drawer.close();
    }
  });
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-cart-open]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); open(trigger);
    if (busy) return;
    message('');setBusy(true);
    try {await refresh();} catch {message('Your bag could not refresh. Use “View full bag” to check your current items.');}
    finally {setBusy(false);}
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    const button = form.querySelector('[data-add-button]');
    if (button.disabled) return;
    const productError = form.querySelector('[data-add-error]');
    productError.hidden = true;
    const original = button.innerHTML;
    const payload = new FormData(form);
    payload.set('sections', section); payload.set('sections_url', cartURL);
    setBusy(true);button.disabled = true;button.textContent = 'Adding…';
    let accepted = false;
    try {
      const response = await fetch(drawer.dataset.cartAddUrl + '.js', {method:'POST',body:payload,headers:{Accept:'application/json'}});
      const data = await response.json();
      if (!response.ok || data.status >= 400) {
        productError.textContent = typeof data.description === 'string' ? data.description : 'This item could not be added. Please check its availability.';
        productError.hidden = false;return;
      }
      accepted = true;changed = true;message('');
      await applyResponse(data);open(button);
    } catch {
      productError.textContent = accepted ? 'Added to your bag, but the drawer could not refresh. Open the full bag to continue.' : 'We could not confirm whether this was added. Check your bag before trying again.';
      productError.hidden = false;
    } finally {
      setBusy(false);button.innerHTML = original;
      const selected = form.querySelector('[data-variant-select]')?.selectedOptions[0];
      button.disabled = selected ? (!selected.value || selected.disabled) : false;
    }
  });
  drawer.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-change]');
    if (!button || busy) return;
    const quantity = Number(button.dataset.quantity);
    if (!Number.isInteger(quantity) || quantity < 0) return;
    const key = button.dataset.cartChange;
    const direction = button.getAttribute('aria-label')?.startsWith('Increase') ? 'Increase' : 'Decrease';
    message('');setBusy(true);
    try {
      const response = await fetch(drawer.dataset.cartChangeUrl + '.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:[section],sections_url:cartURL})});
      const data = await response.json();
      if (!response.ok || data.status >= 400) {
        message(typeof data.description === 'string' ? data.description : 'That quantity is not available.');return;
      }
      changed = true;await applyResponse(data);
      const focus = Array.from(drawer.querySelectorAll('[data-cart-change]')).find(el => el.dataset.cartChange === key && el.getAttribute('aria-label')?.startsWith(direction));
      (focus || drawer.querySelector('[data-cart-close]')).focus();
    } catch {message('We could not confirm the update. Reopen your bag to refresh it before trying again.');}
    finally {setBusy(false);}
  });
})();
